import { Attribute, Directive } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  NG_VALIDATORS,
  Validator,
  ValidatorFn,
} from '@angular/forms';

@Directive({
  selector: '[hbRange][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: RangeValidator, multi: true },
  ],
})
export class RangeValidator implements Validator {
  validator: ValidatorFn;

  constructor(
  @Attribute('min') min: number,
    @Attribute('max') max: number,
    @Attribute('minInclusive') minInclusive: boolean,
    @Attribute('maxInclusive') maxInclusive: boolean,
    @Attribute('rangeRequired') required: boolean,
  ) {
    this.validator = this.validateRange(min, max, minInclusive, maxInclusive, required);
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  validateRange(min: number, max: number, minInclusive: boolean, maxInclusive: boolean, required: boolean): ValidatorFn {
    return (c: AbstractControl) => {
      let isValid = true;

      if (c.value || c.value === 0) {
        if (min || min === 0) {
          if (minInclusive) {
            isValid = c.value >= min;
          } else {
            isValid = c.value > min;
          }
        }

        if (isValid && (max || max === 0)) {
          if (maxInclusive) {
            isValid = c.value <= max;
          } else {
            isValid = c.value < max;
          }
        }
      } else if (required) {
        isValid = false;
      }

      if (isValid) {
        return null;
      } else {
        return {
          range: {
            valid: false,
          },
        };
      }
    };
  }
}
